// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  bookmarkId: __t.u64().primaryKey().name("bookmark_id"),
  owner: __t.identity(),
  civ: __t.string(),
  systemId: __t.string().name("system_id"),
  x: __t.f64(),
  y: __t.f64(),
  z: __t.f64(),
  label: __t.string(),
  kind: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
